<script lang="ts">
    import { Icon } from "@lernetz/svelte-icon";
    import { setupSharedProps, sharedProps } from "../../setup";
    import Page1 from "../../ui/dashboard/create/Page1.svelte";
    import Page2 from "../../ui/dashboard/create/Page2.svelte";
    import Page3 from "../../ui/dashboard/create/Page3.svelte";
    import Footer from "../../ui/Footer.svelte";

    setupSharedProps();

    export let categories;
    let currentPage = 1;
    let formData = {
        name: "",
        lang: "de",
        cycle: "cycle1",
        selectedCategories: [] as number[],
        email: "",
    };

    function next() {
        currentPage = Math.min(currentPage + 1, 3);
    }

    function back() {
        currentPage = Math.max(currentPage - 1, 1);
    }

</script>
<div class="fixed right-12 top-12 md:right-24 md:top-24 z-20">
  <Icon name="{sharedProps.currentLocale == 'de' ? 'logo-element-hero' : 'logo-element-hero-fr'}" class="w-96 md:w-128 xl:w-160"></Icon>
</div>
<div class="bg-blue-light w-full h-full overflow-y-auto fixed inset-0 flex flex-col">
    <div class="flex-1 w-full flex items-start justify-center px-16 md:px-24 pt-72 pb-24 md:py-24">
        {#if currentPage === 1}
          <Page1 bind:formData on:next={next} />
        {:else if currentPage === 2}
          <Page2 {formData} {categories} on:next={next} on:back={back} />
        {:else if currentPage === 3}
          <Page3 {formData} on:next={next} on:back={back} />
        {/if}
    </div>
    <Footer />
</div>
